import React from 'react';

const ReviewRequirements = () => {
  return (
    <div>
      <h4>Requisitos Técnicos</h4>
      <p>Para asegurar la correcta prestación del servicio será necesario que el equipo cumpla las siguientes especificaciones técnicas:</p>
      <ol>
        <li><strong>Conexión a internet mínima:</strong> 512 Kbps de subida/bajada.</li>
        <li><strong>Requisitos mínimos para PC y MAC:</strong> Microsoft Windows (versiones soportadas por el fabricante), Apple MAC OS (versiones soportadas por el fabricante, con procesador Intel).</li>
      </ol>
    </div>
  );
};

export default ReviewRequirements;
